import { FunctionComponent, memo, useMemo } from 'react';
import { DeploymentEnvironment } from 'env/environments';
import { useSessionManagement } from 'src/services/auth/session/hooks/useSessionManagement';
import { useExperiments } from 'src/providers/ExperimentProvider';
import { FeatureFlagStatus, ActiveSplitExperiment } from 'src/services/experiments/client/ongoingExperiments';
import { IDP_LOGOUT_ENDPOINT } from 'src/services/auth/constants';
import { HEADER_VERSIONS } from './constants';
import { useZillowNavbarState } from './hooks/useZillowNavbarState';
import { ZillowNavbar } from './ZillowNavbar';
import { UserNavigationData } from './components/AccountManagement/types/UserNavigationData';
type WiredZillowNavbarProps = {
    /**
     * which environment this is deployed in
     */
    env: DeploymentEnvironment;
    /**
     * The header version to render
     */
    version: HEADER_VERSIONS;
};

export const WiredZillowNavbar: FunctionComponent<WiredZillowNavbarProps> = memo(({ env, version }) => {
    const { staticDomainConfig, zhlHost, links } = useZillowNavbarState({ env });
    const { startSession, endSession, session } = useSessionManagement();
    const { experiments } = useExperiments();
    const shouldUseAuth0 =
        experiments[ActiveSplitExperiment.HOME_LOANS_DASHBOARD_AUTH_MIGRATION]?.treatment === FeatureFlagStatus.ON;
    const userNavigationData: UserNavigationData | null = useMemo(
        () =>
            session
                ? {
                      userAvatarData: {
                          displayName: session?.user?.name,
                          email: session?.user?.email,
                          photo: session?.user?.image,
                      },
                      navLinks: {},
                  }
                : null,
        [session]
    );
    return (
        <ZillowNavbar
            userNavigationData={userNavigationData}
            useAuth0={shouldUseAuth0}
            onAuth0SignIn={() => startSession('Navbar Sign In')}
            onAuth0SignOut={async () => {
                endSession('Navbar Sign Out', {
                    callbackUrl: IDP_LOGOUT_ENDPOINT,
                });
            }}
            version={version}
            zhlHost={zhlHost}
            links={links}
            staticDomainConfig={staticDomainConfig}
        />
    );
});
